import React from 'react';
import { Route, IndexRoute, Link } from 'react-router';
import map from 'lodash/map';
import MainLayout from './Layouts/MainLayout';
import NotFound from './containers/NotFound/NotFound';
/* import { debug } from '../utils';
 * const log = debug('lego:routes');*/

const siteTitle = 'AccessPlace';
interface Routes {
		[route: string]: {
				path: string;
				label: string;
				title: string;
				component: any;
		}
}

import { HomeRoutes } from './containers/Home';
import { SearchRoutes } from './containers/Search';
import { PlaceRoutes } from './containers/Place';
import { AccountRoutes } from './containers/Account';
import { ProfileRoutes } from './containers/Profile';
import { HelpRoutes } from './containers/Help';
import { AboutRoutes } from './containers/About';
import { LoginRoutes } from './containers/Login';
import { RegisterRoutes, TermsRoutes } from './containers/Register';
import { WizardRoutes } from './containers/Wizard';

export const routes: Routes = Object.assign(
		{} as Routes,
		HomeRoutes,
		SearchRoutes,
		HelpRoutes,
		PlaceRoutes,
		ProfileRoutes,
		AccountRoutes,
		AboutRoutes,
		LoginRoutes,
	RegisterRoutes,
	TermsRoutes,
		WizardRoutes
);

const indexRoute = (route) => Object.assign({}, route, { path: null });

export const LinkHelper = ({to, className='', children=undefined, ...props}) => {
		const to_path = routes[to] ? routes[to].path : to;
		// if (!routes[to]) throw new Error(`Route to '${to}' not found`);
		return (
				<Link to={ to_path } className={className} { ...props }>
						{ children || routes[to].label }
				</Link>
		);
};

export function makeRoutes() {
		const home = routes['home'];
		const index = indexRoute(home);
		const NOT_FOUND_ROUTE_PROPS = {title: `${siteTitle} - Page Not Found`};

		return (
				<Route path='/' component={ MainLayout }>
						<IndexRoute { ...index } />
						{ map(routes, (route, name) => route != home && (<Route {...route} key={`${name}-route`} />) ) }
						<Route path='*' {...NOT_FOUND_ROUTE_PROPS} component={ NotFound } />
				</Route>
		);
}



// WEBPACK FOOTER //
// ./src/app/routes.tsx